module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_black-joker.988e93f3.svg";